import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';

export {
  ApiResponseError as AnioAcademicoApiError,
  ApiSessionTimeoutError as AnioAcademicoSessionTimeoutError,
  classifyApiError as classifyAnioAcademicoError,
  unwrapResponseModel
};

export function toSaveAnioAcademicoPayload(descripcion) {
  return { AnioAcademicoDescripcion: descripcion };
}

export function toUpdateAnioAcademicoPayload({ id, descripcion }) {
  return {
    AnioAcademicoDescripcion: descripcion,
    AnioAcademicoCod: parseInt(id, 10)
  };
}

export function validateAnioAcademicoDescripcion(descripcion) {
  return Boolean(descripcion?.length > 0);
}
